'use client';

import { CONTINENT } from "@/contants";
import StandingService from "@/services/standingService";
import { useEffect, useState } from "react";
import { Image } from '@/lib/target';
import { Link } from '@/lib/target';
import BreadcrumbStanding from "../BreadcrumbStanding";
import { usePathname } from "@/lib/target";
import StandingHeader from "../StandingHeader";
import LoadingInner from "@/app/loadingInner";

const FifaRanking = ({params}) => {
  
  let {slug, continent, type} = params;
  if (!continent) {
    continent = 'the-gioi';
  }
  
  if (slug === undefined && type === 1) {
    slug = 'nam';
  }

  if (slug === undefined && type === 2) {
    slug = 'nu';
  }
  
  const tabs = []
  const [activeTabList, setActiveTabList] = useState(continent);
  const [data, setData] = useState([]);
  const [continentT, setContinent] = useState(continent);
  const [visibleItems, setVisibleItems] = useState(20);
  
  useEffect(() => {
    const fetchData = async () => {
      if (activeTabList) {
        try {
          const {data} = await StandingService.getFifaRanking(type);
          setData(data);
        } catch (error) {
          console.error("Error fetching standings:", error);
        }
      }
    };
    fetchData();
  }, []);  

  useEffect(() => {
    setVisibleItems(20);
  },[activeTabList])
  const pathname = usePathname();
  const pathArray = pathname.split('/').filter((path) => path);
  const path = pathArray[pathArray.length - 1];

  return (
    <div className="standing-list rounded w-full mx-auto @md:px-2 !text-xxs @md:!text-xs">

      <ul id="tabs" className="h-9 hidden @md:flex w-full text-xs z-10 px-2">
        {CONTINENT.map((item, index) => (
          <li key={index} className="flex items-center justify-center">
            <Link  
              onClick={() => {
                setActiveTabList(item.eng),
                setContinent(item.eng)              
                }}
              href={`/bxh-fifa-${slug}/${item.slug}`}
              key={item.id}
              className={`cursor-pointer text-gray-800 dark:text-white ${ path === item.slug ? 'font-semibold relative before:absolute before:left-0 before:h-0.5 before:-bottom-1 before:w-full before:bg-button-blue-bet dark:before:bg-white z-1' : '' }`}
              >
              {item.vn}
            </Link>
            <div className={`mx-4 pb-1 h-4`}></div>
          </li>
        ))}
      </ul>

      <div className="@md:hidden">
        <StandingHeader leagues={CONTINENT} type={`bxh-fifa-${slug}/`} />
      </div>
      <div className="pl-2 mt-2"><BreadcrumbStanding className="@md:flex hidden"/></div>
      <div id="tab-contents">
        <FifaRankingContent 
          data={data} 
          continent={continentT} 
          visibleItems={visibleItems} 
          setVisibleItems={setVisibleItems}
          />
      </div>
    </div>
  );
};

const TranslateContinent = (continent) => {
  const continentObj = CONTINENT.find((item) => item.eng === continent);
  return continentObj?.vn;
};

export const FifaRankingContent = ({data, continent, visibleItems, setVisibleItems}) => {
  
  if (!continent) {
    continent = 'the-gioi';
  }
  if (continent !== 'the-gioi' && continent !== undefined && continent !== null) {
    data = data.filter((item) => item.continent === CONTINENT.find((item) => item.slug === continent)?.eng);
  }
  
  return (
    <div className="text-center px-2 @md:px-7 pb-5 mt-4">
      {(!data || data.length === 0) ? <LoadingInner /> : <>
        <div className="flex w-full grow justify-between h-7 bg-stroke-o3 dark:bg-black rounded ">
          <div className="w-7 pl-2 @md:w-9  mr-3 @md:mr-5 text-center flex items-center justify-center">#</div>
          <div className="w-96 text-left flex items-center justify-start">Tuyển Quốc Gia</div>
          <div className="flex w-60 justify-between">
            <div className="w-full flex items-center justify-center">Khu Vực</div>
          </div>
          <div className="flex w-60 justify-between">
            <div className="w-full flex items-center justify-center">Điểm</div>
          </div>
          <div className="flex w-20 @md:w-60 justify-between">
            <div className="w-full flex items-center justify-center">HS</div>
          </div>
          <div className="w-60 @md:w-44 flex items-center justify-center">Điểm trước</div>
        </div>
        {data?.sort((a, b) => b.score - a.score).slice(0, visibleItems).map((item, index) => (
          <div key={index} className="flex w-full grow justify-between h-8 even:bg-header-blue dark:even:bg-dark-slate dark:odd:bg-midnight-slate items-center text-dark-gray dark:text-white">
            <div className="w-8 mr-3 pl-2 @md:mr-5">{index + 1}</div>
            <div className="w-96 text-left flex">

              <Image alt="Net88" src={item.teams.logo || 'https://demofree.sirv.com/nope-not-here.jpg'} width={20} height={20} />
              <span className="ml-2">{item.teams.name}</span>
            </div>
            <div className="flex w-60 justify-between">
              <div className="w-full">{TranslateContinent(item.continent)}</div>
            </div>
            <div className="flex w-60 justify-between">
              <div className="w-full font-bold">{item.score}</div>
            </div>
            <div className="flex w-20 @md:w-60 justify-between">
              <div className="w-full font-bold">{item.scoreChange}</div>
            </div>
            <div className="w-60 @md:w-44 font-bold">{item.score - item.scoreChange}</div>
          </div>
        ))}
        {visibleItems < data.length && (
          <button
            onClick={() => setVisibleItems(visibleItems + 20)}
            className="mt-4 p-2 bg-gradient-start text-dark-gray rounded uppercase hover:text-white hover:bg-gradient-end"
          >
            {`(${visibleItems}/${data.length}) Xem thêm +20`}
          </button>
        )}
      </>}
    </div>
  );
};
export default FifaRanking;